import React from 'react';
import '../../styles/loader.css';

const Loader = ({ 
  size = 'md', 
  text = '',
  fullScreen = false,
  overlay = false
}) => {
  if (fullScreen) {
    return (
      <div className="loader-fullscreen">
        <div className={`loader loader-${size}`}>
          <div className="spinner"></div>
          {text && <p className="loader-text">{text}</p>}
        </div>
      </div>
    );
  }

  if (overlay) {
    return (
      <div className="loader-overlay">
        <div className={`loader loader-${size}`}>
          <div className="spinner"></div>
          {text && <p className="loader-text">{text}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className={`loader loader-${size}`}>
      <div className="spinner"></div>
      {text && <p className="loader-text">{text}</p>}
    </div>
  );
};

export default Loader;